import { Port } from '../../types/models'
import { EVSEPortControl } from './EVSEPortControl'
import { FirmwareInfoPortControl } from './FirmwareInfoPortControl'
import { PortControl } from './PortControl'
import { SimplePowerMeterPortControl } from './SimplePowerMeterPortControl'
import { RelayPortControl } from './RelayPortControl'
import { TemperaturePortControl } from './TemperaturePortControl'
import { P3PowerMeterPortControl } from './P3PowerMeterPortControl'
import { FuturePortControl } from './FuturePortControl'
import { SolarPortControl } from './SolarPortControl'
import { ClockPortControl } from './ClockPortControl'
import { DeviceControl } from '../DeviceControl'
import { PortConfig, PortType } from '../../types/ports'
import { RS485PortContrl } from './RS485PortControl'
import { OptimizerPortControl } from './OptimizerPortControl'
import { OptimizerControlPortControl } from './OptimizerControlPortControl'
import { OptimizerPricePortControl } from './OptimizerPricePortControl'
import { OptimizerWeatherPortControl } from './OptimizerWeatherPortControl'
import { HanPowerMeterPortControl } from './HanPowerMeterPortControl'
import { RadioPortControl } from './RadioPortControl'
import { BatteryOptimizerPortControl } from './BatteryOptimizerPortControl'
import { BatteryOptimizer2PortControl } from './BatteryOptimizer2PortControl'
import { BatteryOptimizerSocPlanPortControl } from './BatteryOptimizerSocPlanPortControl'
import { EnergyStoragePortControl } from './EnergyStoragePortControl'
import { NetsumPowerMeterPortControl } from './NetsumPowerMeterPortControl'
import { HeatPumpPortControl } from './HeatPumpPortControl'

const PortTypes: Record<PortType, typeof PortControl<Port, PortConfig>> = {
  BATTERY_OPTIMIZER: BatteryOptimizerPortControl,
  BATTERY_OPTIMIZER2: BatteryOptimizer2PortControl,
  BATTERY_OPTIMIZER_SOC_PLAN: BatteryOptimizerSocPlanPortControl,
  CLOCK: ClockPortControl,
  DIAGNOSTICS: FuturePortControl,
  EM_3PH: P3PowerMeterPortControl,
  EM_SIMPLE: SimplePowerMeterPortControl,
  EM_HAN: HanPowerMeterPortControl,
  EM_NETSUM: NetsumPowerMeterPortControl,
  ENERGY_STORAGE: EnergyStoragePortControl,
  EVSE: EVSEPortControl,
  FW_INFO: FirmwareInfoPortControl,
  GPIO: FuturePortControl,
  HEAT_PUMP: HeatPumpPortControl,
  OPTIMIZER_PRICE: OptimizerPricePortControl,
  OPTIMIZER_CONTROL: OptimizerControlPortControl,
  OPTIMIZER_WEATHER: OptimizerWeatherPortControl,
  OPTIMIZER: OptimizerPortControl,
  RADIO: RadioPortControl,
  RELAY: RelayPortControl,
  RS485: RS485PortContrl,
  SCHEDULER: FuturePortControl,
  SOLAR: SolarPortControl,
  TEMPERATURE: TemperaturePortControl,
}

/**
 * Instantiate a port controller for the given port.
 */
export function getPortController(deviceControl: DeviceControl, port: Port) {
  // Fall back to the inert FuturePortControl for any type this build does not
  // know about (e.g. a port persisted by a newer server, or "UNKNOWN" emitted
  // by the server's int2type fallback after a rollback). Throwing here would
  // crash the whole device view for one unrecognized port.
  const Control = PortTypes[port.type] ?? FuturePortControl
  return new Control(deviceControl, port)
}
